import { Skeleton, Stack } from '@mui/material';

export const CategoryChipSkeleton = () => (
  // No own margin/overflow styling — this is always rendered inside a parent
  // that already owns spacing (mb) and overflowX:'auto' (BreakingCategories,
  // SearchAndFilters' CategoryChipList wrapper); adding our own here doubled
  // the vertical spacing once real chips (which have none) swapped in.
  <Stack direction="row" spacing={1}>
    {[...Array(12)].map((_, index) => (
      <Skeleton
        key={index}
        variant="rounded"
        width={80}
        height={32}
        sx={{ borderRadius: '16px', flexShrink: 0 }}
      />
    ))}
  </Stack>
);
